function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AnalyticsService
 *
 * Creates an analyticsBookedItem with an altered version of the bookedItem as property
 * and additional custom properties. Type of the bookedItem is restored to its original parentItem type.
 * Also capable of creating an analyticsObject.
 *
 * @see     https://support.iso-gruppe.com/browse/IBEMOD-1031
 *
 * @remarks The doc comments are written according to the TSDoc notation (https://tsdoc.org/).
 *
 * @author  Güven Gökdemir  <gueven.goekdemir@isotravel.com>
 */
var AnalyticsService = /*#__PURE__*/function () {
  function AnalyticsService() {
    _classCallCheck(this, AnalyticsService);
  }
  _createClass(AnalyticsService, null, [{
    key: "decodeIdParent",
    value:
    /**
     * Decodes the idParent into an ApiBaseModel variable
     * and returns the actual idParent as a string.
     *
     * @param idParent - Encoded base64 string
     * @returns The decoded idParent from the decoded ApiBaseModel
     */
    function decodeIdParent(idParent) {
      try {
        var decodedIdParentJSON = atob(idParent);
        var decodedIdParentModel = JSON.parse(decodedIdParentJSON);
        return decodedIdParentModel.idParent;
      } catch (e) {
        return idParent;
      }
    }
    /**
     * Extracts the parent item of multiple items
     *
     * @param idParent - ID of the desired parent item
     * @param itemType - Additional criteria to be used to distinguish between all items
     * @param booking - BookingObject of the bookingService
     * @returns The parent item, that matches the search results
     */
  }, {
    key: "extractParentItem",
    value: function extractParentItem(idParent, itemType, booking) {
      return booking.items.find(function (item) {
        return item.idParent === null && item.id === idParent && item.itemType === itemType;
      });
    }
    /**
     * Gets the value of a property and casts it into the specified Type T
     *
     * @param key - The key of that specific value
     * @param property - The property of which the value should be extracted from
     * @returns The value cast as Type T
     */
  }, {
    key: "getPropertyValueCasted",
    value: function getPropertyValueCasted(key, property) {
      var _property$keyStr;
      var keyStr = key;
      return (_property$keyStr = property[keyStr]) === null || _property$keyStr === void 0 ? void 0 : _property$keyStr.valueOf();
    }
    /**
     * Creates an analyticsBookedItem, which consists of an altered bookedItem
     * and additional properties.
     *
     * @remarks The original type of the item, that has been booked is going to be set ...(line-break not supported here)
     * inside the bookedItem (from 'BookedItem' to e.g. 'ExtraService').
     * The additional properties are serviceType and category, these can be extended if needed.
     *
     * @param bookedItem - Item to be used as property
     * @param booking - BookingObject of the bookingService
     * @returns New analyticsBookedItem with the altered bookedItem as property
     */
  }, {
    key: "createItem",
    value: function createItem(bookedItem, booking) {
      var decodedIdParent = null;
      if (bookedItem.idParent) {
        decodedIdParent = this.decodeIdParent(bookedItem.idParent);
      }
      var extractedParentItem;
      // Since the bookedItem sometimes only consists of one item it won't have a parent item,
      // therefore the idParent will be the same as the id.
      if (bookedItem.id === bookedItem.idParent || !decodedIdParent) {
        extractedParentItem = this.extractParentItem(bookedItem.id, bookedItem.itemType, booking);
      } else {
        extractedParentItem = this.extractParentItem(decodedIdParent, bookedItem.itemType, booking);
      }
      if (extractedParentItem) {
        bookedItem.type = extractedParentItem.type;
        var serviceType = this.getPropertyValueCasted('serviceType', extractedParentItem);
        var category = this.getPropertyValueCasted('category', extractedParentItem);
        // Individual property request of IBEMOD-1031:
        var serviceClass = {
          code: bookedItem.type,
          description: bookedItem.itemType
        };
        var analyticsCustomizedBookedItem = {
          bookedItem: bookedItem,
          serviceType: serviceType,
          category: category,
          serviceClass: serviceClass
        };
        return analyticsCustomizedBookedItem;
      } else {
        return null;
      }
    }
    /**
     * Creates an analyticsObject which consists of all analyticsBookedItems
     *
     * @param booking - BookingObject of the bookingService
     * @returns New analyticsObject with bookedItems array
     */
  }, {
    key: "createAnalyticsObject",
    value: function createAnalyticsObject(booking) {
      var _this = this;
      if (booking && booking.bookedItems) {
        var analyticsObj = {
          bookedItems: []
        };
        booking.bookedItems.forEach(function (item) {
          var analyticsBookedItem = _this.createItem(item, booking);
          if (analyticsBookedItem) {
            analyticsObj.bookedItems.push(analyticsBookedItem);
          }
        });
        return analyticsObj;
      } else {
        return null;
      }
    }
  }]);
  return AnalyticsService;
}();

export { AnalyticsService, AnalyticsService as default };
//# sourceMappingURL=AnalyticsService.js.map
